import { Redirect, Stack } from "expo-router";
import { useState } from "react";
import { Platform } from "react-native";
import { CalendarProvider } from "react-native-calendars";
import { Verify } from "~/components/form/auth/Verify";
import { HeaderButton } from "~/components/HeaderButton";
import { PaperTheme } from "~/components/PaperTheme";
import { useDismiss } from "~/providers/DismissProvider";
import { NotificationsProvider } from "~/providers/NotificationsProvider";
import { ProfileProvider } from "~/providers/ProfileProvider";
import { useSession } from "~/providers/SessionProvider";
import { SurveyProvider } from "~/providers/SurveyProvider";
import { useTheme } from "~/providers/ThemeProvider";
import { UserProvider } from "~/providers/UserProvider";
import { formatDateString } from "~/util/dates";

export const unstable_settings = {
    initialRouteName: "dashboard",
};

export default function AuthLayout() {
    const { dark } = useTheme();
    const { colours, paperTheme } = useTheme();
    const { hydrated, logged_in, active } = useSession();
    const { handleDismiss } = useDismiss();

    const now = formatDateString(new Date());
    const [date, setDate] = useState(now);

    if (!hydrated) {
        return;
    }

    if (!logged_in) {
        return <Redirect href="/start" />;
    }

    if (logged_in && !active) {
        return <Verify />;
    }
    return (
        <PaperTheme theme={paperTheme}>
            <UserProvider>
                <CalendarProvider date={date} onDateChanged={setDate}>
                    <ProfileProvider>
                        <NotificationsProvider>
                            <SurveyProvider>
                                <Stack
                                    screenOptions={{
                                        headerLeft: () => (
                                            <HeaderButton onPress={handleDismiss} title="Back" icon="chevron-left" />
                                        ),
                                        headerTransparent: true,
                                        title: "",
                                        headerTitleAlign: "center",
                                        headerTitleStyle: {
                                            fontWeight: 600,
                                            fontSize: 16,
                                            color: colours.text.primary,
                                        },
                                        statusBarStyle: Platform.select({
                                            android: dark ? "light" : "dark",
                                            default: undefined,
                                        }),
                                    }}
                                />
                            </SurveyProvider>
                        </NotificationsProvider>
                    </ProfileProvider>
                </CalendarProvider>
            </UserProvider>
        </PaperTheme>
    );
}
